<template>
  <div class="the-navbar__user-meta flex items-center" v-if="userInfo.username">

    <div class="text-right leading-tight hidden sm:block">

    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <icon-svg class="user-avatar" :icon-class="'avatar'"></icon-svg>
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer dropdown-item"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{'退出登录'}}</span>
          </li>
        </ul>
<!--        <div class="self-box display-flex" style="max-width: 9rem;">-->
<!--          <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />-->
<!--          <span class="ml-2">{{'退出登录'}}</span>-->
<!--        </div>-->
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
  import firstLetter from '@/components/public/firstLetter'
import { mapGetters } from 'vuex'
export default {
    components:{
      firstLetter,
    },
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    firstLetter(){
      return this.userInfo.username.toUpperCase().charAt(0);
    }
  },
  methods: {
    logout() {
      // This is just for demo Purpose. If user clicks on logout -> redirect
      localStorage.clear();
      this.$router.push({name: 'login'}).catch(() => {})
    },
  }
}
</script>
<style lang="scss" scoped>
  @import "../../../../assets/scss/variable";
.user-avatar {
  font-size: 28px;
}
.dropdown-item {
  &:hover {
    color: $themeColor;
  }
}

</style>
